<template>
  <div>
    <List
      url="roles/"
      :title="title"
      :tanle="tanle"
      :data="searchData"
      titleClass="title"
      :operat="operat"
      :update="updateList"
      :afterList="dealList"
      @edit="edit"
      @setting="setting"
      @deletedata="deletedata"
    >
      <div slot="Filter" style="display: flex;line-height:35px;">
        <label>角色名：</label>
        <el-input
          v-model="searchData.name"
          style="width:200px;margin-right:30px;"
        ></el-input>
        <el-button @click="updateList++" type="primary" size="small"
          >搜索</el-button
        >
      </div>
      <template slot="Fresh">
        <el-button
          @click="add"
          type="primary"
          style="margin-bottom:10px;float:right"
          >新增</el-button
        >
      </template>
    </List>
    <UpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
    ></UpdateBox>
  </div>
</template>
<script>
import List from "../components/common/List.vue";
import UpdateBox from "../components/RoleControl/UpdateBox.vue";
export default {
  components: {
    List,
    UpdateBox
  },
  data() {
    return {
      tanle: [
        { name: "name", label: "角色名称" },
        { name: "desc", label: "描述" },
        { name: "menuName", label: "权限" }
      ],
      title: "角色管理",
      operat: [
        {
          text: "Edit",
          eventName: "edit"
        },
        {
          text: "Setting",
          eventName: "setting"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],
      searchData: {
        name: ""
      },
      is_admin: false,
      updateType: "edit",
      updateList: 0,
      updateBlock: false,
      updateForm: {}
    };
  },
  computed: {
    menuGroup() {
      let menuGroup = this.$store.state.menuGroup;
      return menuGroup;
    }
  },
  methods: {
    dealList(data) {
      for (let i in data) {
        data[i].menuName = "";
        for (let k in data[i].menus) {
          for (let l in this.menuGroup) {
            if (data[i].menus[k] == this.menuGroup[l].ID) {
              data[i].menuName += this.menuGroup[l].Name + "  ";
            }
          }
        }
      }
      return data;
    },
    edit(val) {
      this.updateBlock = true;
      this.updateType = "edit";
      this.updateForm = Object.assign({}, val);
    },
    add() {
      this.updateBlock = true;
      this.updateType = "add";
      this.updateForm = {};
    },
    deletedata(val) {
      let url = "roles/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    setting(val) {
      this.updateBlock = true;
      this.updateType = "setting";
      this.updateForm = Object.assign({}, val);
    },
    close() {
      this.updateBlock = false;
    }
  }
};
</script>
